import React, { useState } from 'react';
import styled from 'styled-components';
import './CircularMenu.css';

const CircularMenu = () => {

  return (
<div className='full-height'><nav class="menu">
  <input class="menu-toggler" type="checkbox"/>
  <label for="menu-toggler"></label>
  <ul>
  <a href="https://www.linkedin.com/in/siya-gampawar-45b066237/">
    <li class="menu-item">
      <img src = './Linkedin.svg'/>
    </li>
    </a>
    
    <li class="menu-item">
      <img src="./Github.svg" alt="GitHub"/>
    </li>
    <li class="menu-item">
      {/* <a class="fab fa-earlybirds" href="#"></a> */}
      <img src='Mail.svg'/>
    </li>
    <li class="menu-item">
      {/* <a class="fab fa-fly"href="#"></a> */}
      <img src='Instagram.svg'/>
    </li>
    <li class="menu-item">
      {/* <a class ="far fa-gem" href="#"></a> */}
      <img src = './Discord.svg'/>
    </li>
    {/* <li class="menu-item">
      <a class="fas fa-glass-cheers" href="#"></a>
    </li> */}
  </ul>
</nav></div>
  );
};

export default CircularMenu;
